<div>
  <div class="flex justify-end p-5">
    <a wunButton primary routerLink="./new">Crea nuovo</a>
  </div>
</div>
<div class="flex flex-col p-4">
  @for (slide of slides.value(); track slide.id) {
    <div class="flex p-4" [class.bg-gray-100]="$even" [class.bg-gray-200]="$odd">
      <div class="w-full">
        @let img = slide.images[0] ? slide.images[0] : null;
        @if (img) {
          <img class="w-40 h-20 object-cover" [src]="img.url" />
        }
      </div>
      <div class="flex gap-4 items-center">
        <button wunButton (click)="deleteSlide(slide)">Rimuovi</button>
        <a wunButton primary [routerLink]="'./' + slide.id">Modifica</a>
      </div>
    </div>
  }
</div>

